export class Property {
    _name;
    _value;
    _layer;
    constructor(name, value, layer = undefined) {
        this._name = name;
        this._value = value;
        this._layer = layer;
    }
    getName() {
        return this._name;
    }
    getValue() {
        return this._value;
    }
    setValue(value) {
        this._value = value;
        return this;
    }
    format(useUnits = true) {
        if (this._layer === undefined) {
            throw new Error("Formatter must be set before formatting value");
        }
        return this._layer
            .getFormatter()
            .formatValue(this._value, this._layer.getAttribute(this._name).getResultsAttribute(), useUnits);
    }
}
//# sourceMappingURL=Property.js.map